import NotificationsIcon from "@mui/icons-material/Notifications";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useProfile } from "../../contexts/ProfileContext.tsx";
import { visualizaNotificacao } from "../../services/ModuloGerenciador/Notificacoes";
import CustomButton from "../CustomButton/CustomButton";
import CustomButtonV2 from "../CustomButtonV2/CustomButtonV2.js";
import "../ModalNotificacao/ModalNotificacao.css";

export interface SimpleDialogProps {
	titulo?: any;
	tituloBotao?: string;
	tituloConfirmar?: string;
	texto?: string;
	dataAlteracao?: string;
	open: boolean;
	onClose: () => void;
	onClick?: () => void;
}

function ModalNotificacao(props: SimpleDialogProps) {
	const { coresEmpresa, profile } = useProfile();

	const { onClose, open } = props;

	const logout = () => {
		localStorage.removeItem("usuario");
		localStorage.removeItem("token");
		localStorage.removeItem("dadosFilial");
		localStorage.removeItem("expiracao");
		localStorage.removeItem("Cookies");
		localStorage.removeItem("flagPassword");
		localStorage.removeItem("expirateTime");
		window.location.reload();
	};

	const visualizarNotificao = async () => {
		await visualizaNotificacao(
			profile?.usuario.idUsuario,
			props.titulo.notificacaoId,
			profile?.token
		)
			.then((result) => {
				if (result.status === 200) {
					onClose();
					localStorage.removeItem("notificacaoId");
					if (props.titulo.acao === "logout") {
						logout();
					} else {
						const url = props.titulo.acao.split(" ");
						if (url[0] == "redirecionar") window.location.href = url[1];
					}
				}
			})
			.catch((error) => {});
	};

	const handleClick = () => {
		visualizarNotificao();
	};

	const handleClick2 = () => {
		onClose();
	};

	return (
		<div>
			<Dialog open={open}>
				<div className="div-modal-notificacao">
					<div>
						<NotificationsIcon className="icone-notificacao"></NotificationsIcon>
					</div>
					{props.titulo === undefined ? (
						<>
							<DialogTitle id="alert-dialog-title">
								<h2 className="texto-notificacao">Notificação</h2>
							</DialogTitle>
							<DialogContent>
								<DialogContentText id="alert-dialog-description">
									<h3 className="texto-notificacao">
										Nenhuma notificação a ser visualizada
									</h3>
								</DialogContentText>
							</DialogContent>
							<DialogActions>
								<CustomButton
									classCss="custom-button"
									titulo="FECHAR"
									cor={coresEmpresa.botaoPadrao}
									corTexto={coresEmpresa.textoBotaoPadrao}
									onClick={handleClick2}
								/>
							</DialogActions>
						</>
					) : (
						<>
							<DialogTitle id="alert-dialog-title">
								<h2 className="texto-notificacao">{props?.titulo?.titulo}</h2>
							</DialogTitle>
							<DialogContent>
								<DialogContentText id="alert-dialog-description">
									<h3 className="texto-notificacao">
										{props?.titulo?.mensagem}
									</h3>
								</DialogContentText>
							</DialogContent>
							<DialogActions>
								<CustomButtonV2
									classCss="custom-button-cadastrar"
									classText="button-texto-cadastrar"
									titulo="VISUALIZAR"
									cor="#0946B8"
									onClick={handleClick}
								/>
							</DialogActions>
						</>
					)}
				</div>
			</Dialog>
		</div>
	);
}

export default ModalNotificacao;
